import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, Key, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { globalPrompt } from "@/components/message";
import { IStockCheckFields, IDetailList, IStockCheckDetail, IStockCheckSearch, Detailed, IInvalidateAndComplete, IExamine } from "../../stockCheckType"

import { IStockStatisticFields, IStockStatisticSearch, IStockStatisticDetail, stockStatisticService } from "../../../statistic/stockStatisticService"
import { stockCheckService } from "../../stockCheckService"
import moment from "moment";
import { momentFormat, transPgToPagination } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useLockFn } from "ahooks";
export type IStockCheckDescType = {
    stockAll: number,
    checkAll: number,
    SurplusNumAll: number,
    deficitNumAll: number,
    differenceNumAll: number,
    differenceMoneyAll: number,
    differenceRateAll: number,
    differenceRateNumAll: number,
    totalAll: number,
    [key: string]: any
}
export interface IMaterialDetailModel extends IStockStatisticDetail {
    num: number
}
export const useStockCheckDetailModel = createModel(function () {
    const { supplieAllList, CustomerData, technicianData, user, setLocale } = useGlobalModel()
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const initDesc = {
        stockAll: 0,   //库存数量
        checkAll: 0,   //盘点数量
        SurplusNumAll: 0,   //盘盈项数
        deficitNumAll: 0,   //盘亏项数
        differenceNumAll: 0,   //差异数量
        differenceMoneyAll: 0,   //差异金额
        differenceRateAll: 0,   //差异率
        differenceRateNumAll: 0, //数量差异率
        totalAll: 0, //系统库存总金额
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: object = {};
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IStockCheckFields>({ createUser: user.username })
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);
    const [addDesc, setAddDesc] = useState<IStockCheckDescType>(initDesc)


    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IStockCheckFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<IStockCheckDescType>(initDesc)

    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);
    const [detailEditForm, setDetailEditForm] = useState<IStockCheckFields>({})
    const [editDesc, setEditDesc] = useState<IStockCheckDescType>(initDesc)

    //退货配件弹框配置
    const [workDataSource, setWorkDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IStockStatisticSearch>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [workRowKeys, setWorkRowKeys] = useState<Key[]>([])
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IMaterialDetailModel[]>([]);
    //判断盘盈盘亏
    const setProfitAndLoss = (differ: number) => {
        if (differ == 0) return "相符"
        if (differ > 0) return "盘盈"
        if (differ < 0) return "盘亏"
    }

    useEffect(() => {
        let newDesc: IStockCheckDescType = { ...initDesc };
        // stockAll: 0,   //库存数量
        // checkAll: 0,   //盘点数量
        // SurplusNumAll: 0,   //盘盈项数
        // deficitNumAll: 0,   //盘亏项数
        // differenceNumAll: 0,   //差异数量
        // differenceMoneyAll: 0,   //差异金额
        // differenceRateAll: 0,   //差异率
        detailAddList?.forEach(item => {
            newDesc.stockAll += Number(item.inventoryNum);
            newDesc.checkAll += Number(item.realNum);
            newDesc.SurplusNumAll += item.result == "盘盈" ? 1 : 0;
            newDesc.deficitNumAll += item.result == "盘亏" ? 1 : 0;
            newDesc.differenceNumAll += Number(item.differenceNum);
            newDesc.differenceMoneyAll += Number(item.differenceAmount);
            newDesc.totalAll += Number(item.inventoryNum) * Number(item.averagePurchasePrice);
        });
        console.log(newDesc.differenceMoneyAll, newDesc.totalAll)
        // newDesc.differenceRateAll = (newDesc.differenceMoneyAll / newDesc.totalAll) * 100;
        newDesc.differenceRateAll = (newDesc.differenceMoneyAll - newDesc.totalAll) / newDesc.totalAll * 100;
        newDesc.differenceRateNumAll = (newDesc.differenceNumAll / newDesc.stockAll) * 100
        setAddDesc(newDesc);
        setDetailAddForm({ ...detailAddForm, result: setProfitAndLoss(newDesc.differenceMoneyAll) })
    }, [detailAddList])

    useEffect(() => {
        let newDesc: IStockCheckDescType = { ...initDesc };
        detailDataSource?.forEach(item => {
            newDesc.stockAll += Number(item.inventoryNum);
            newDesc.checkAll += Number(item.realNum);
            newDesc.SurplusNumAll += item.result == "盘盈" ? 1 : 0;
            newDesc.deficitNumAll += item.result == "盘亏" ? 1 : 0;
            newDesc.differenceNumAll += Number(item.differenceNum);
            newDesc.differenceMoneyAll += Number(item.differenceAmount);
            newDesc.totalAll += Number(item.inventoryNum) * Number(item.averagePurchasePrice);
        });
        newDesc.differenceRateAll = (newDesc.differenceMoneyAll - newDesc.totalAll) / newDesc.totalAll * 100;
        newDesc.differenceRateNumAll = (newDesc.differenceNumAll / newDesc.stockAll) * 100
        setEditDesc(newDesc);
    }, [detailDataSource])

    useEffect(() => {
        let newDesc: IStockCheckDescType = { ...initDesc };
        detailLookList?.forEach(item => {
            newDesc.stockAll += Number(item.inventoryNum);
            newDesc.checkAll += Number(item.realNum);
            newDesc.SurplusNumAll += item.result == "盘盈" ? 1 : 0;
            newDesc.deficitNumAll += item.result == "盘亏" ? 1 : 0;
            newDesc.differenceNumAll += Number(item.differenceNum);
            newDesc.differenceMoneyAll += Number(item.differenceAmount);
            newDesc.totalAll += Number(item.inventoryNum) * Number(item.averagePurchasePrice);
        });
        console.log(newDesc.differenceMoneyAll, newDesc.totalAll)
        newDesc.differenceRateAll = (newDesc.differenceMoneyAll - newDesc.totalAll) / newDesc.totalAll * 100;
        newDesc.differenceRateNumAll = (newDesc.differenceNumAll / newDesc.stockAll) * 100

        setLookDesc(newDesc);
    }, [detailLookList])


    //新增表单缓存
    const updateAddFormVal = (val: IStockCheckFields) => {
        setDetailAddForm({ ...detailAddForm, ...val })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IStockCheckFields) => {
        setDetailEditForm({ ...detailEditForm, ...val })
    }
    //根据id查询一条编辑或查看得数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await stockCheckService.one(id);
        const { details, startTime, endTime, ...from } = retData
        let newfrom = {
            ...from,
            startTime: startTime ? moment(startTime) : null,
            endTime: endTime ? moment(endTime) : null
        }
        let newDetails = details?.map(item => {
            return {
                ...item,
                detailsId: item.id,
            }
        })
        if (retData && pattern == "edit") {
            console.log(newfrom, pattern)
            setDetailDataSource(newDetails as IDetailList[] ?? [])
            setDetailEditForm(newfrom)
        } else if (retData && pattern == "look") {
            setDetailLookForm(newfrom);
            setDetailLookList(newDetails as IDetailList[] ?? [])
        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({});
        workloadData(initPgCfg, {});
    }
    //加载库存统计数据
    const workloadData = async (page?: ISearchPage, searchValue: IStockStatisticFields = searchWorkData) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await stockStatisticService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            return {
                ...item,
                num: 0,
                amount: item.latestPurPrice as number * 0,
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
    }

    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: IMaterialDetailModel[], detailList: IDetailList[]) => {
        const repetition: string[] = [];
        const newDetailData: any[] = []
        modelList.forEach(Item => {
            let { inventoryNum, num, lateSalePrice, latestPurPrice, averagePurchasePrice, realNum, differenceNum, differenceAmount, result } = Item
            let isSelect = detailList?.find(item => item.materialCode == Item.materialCode);
            if (isSelect === undefined) {
                newDetailData.push({
                    ...Item,
                    realNum: realNum ?? num,
                    differenceNum: differenceNum ?? num - Number(inventoryNum),
                    result: result ?? setProfitAndLoss(num - Number(inventoryNum)),
                    detailsId: Item.id,
                    stockId: Item.id,
                    id: "",
                    differenceAmount: differenceAmount ?? ((num - Number(inventoryNum)) * Number(averagePurchasePrice)).toFixed(2)
                });
            } else {
                repetition.push(Item.materialName as string);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToRoDetailList = async (mode: string) => {
        //添加列表
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList)
            setDetailAddList([...detailAddList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `商品名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        } else if (mode == "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `商品名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        }
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string) => {
        if (mode == "add") {
            const filterDetailList = detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele == el.detailsId))
            setDetailAddList(filterDetailList)
            // globalPrompt("message", { text: `删除成功`, type: "success" });
            globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
            setDetaiAddDataRowKeys([]);
            setDetaiAddDataRow([])
        } else if (mode == "edit") {
            const backendDetailList: any = detailDataRow.reduce((all, next) => {  //前端页面维护的需要删除的id
                if (next.id) {
                    all.push({ id: next.id });
                }
                return all;
            }, []);            //删除详情列表调用的方法
            const deleteData = () => {
                const filterDetailList = detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.detailsId))
                // return console.log(filterDetailList)
                setDetailDataSource(filterDetailList)
                // globalPrompt("message", { text: `删除成功`, type: "success" });
                globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
                setDetailDataRowKeys([]);
                setDetailDataRow([])
            }
            if (backendDetailList.length > 0) {
                await stockCheckService.materialDelete({ ids: backendDetailList }).then(res => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        // globalPrompt("message", { text: `删除失败`, type: "success" });
                        globalPrompt("message", { text: Locale["Unsuccessfully deleted"], type: "success" });
                    }
                })
            } else {
                deleteData()
            }
            // const filterDetailList = detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele == el.id))
            // setDetailDataSource(filterDetailList)
            // globalPrompt("message", { text: `删除成功`, type: "success" });
        }
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IStockCheckFields) => {
        let newParams = {
            ...params,
            createUser: user.username,
            startTime: params.startTime ? momentFormat(params.startTime) : null,
            endTime: params.endTime ? momentFormat(params.endTime) : null,
            details: detailAddList
        }
        let { retData } = await stockCheckService.insert(newParams);
        return retData;
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IStockCheckFields) => {
        // momentFormat 
        let newParams = {
            ...params,
            startTime: params.startTime ? momentFormat(params.startTime) : null,
            endTime: params.endTime ? momentFormat(params.endTime) : null,
            details: detailDataSource
        }
        let { retData } = await stockCheckService.update(newParams);
        return retData;
    })
    //下载模板
    const onExport = async () => {
        let result = await stockCheckService.downloadTpl();
        convertRes2Blob(result);
    }
    const onComplete = async (params: IInvalidateAndComplete) => {
        let { retData } = await stockCheckService.complete(params);
        // await stockCheckService.complete(params).then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err.response)
        // })

        // //  console.log(retData)
        return retData
    }
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type: string) => {
        setDetailAddList([]);
        setDetailAddForm({ createUser: user.username })
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }

    const onExamine = async (params:IExamine) => {
        // let { id, stocktakingCode } = detailEditForm as {id:string,stocktakingCode:string }
        // let { retData } = await stockCheckService.examine({ id, stocktakingCode });
        let { retData } = await stockCheckService.examine(params);
        return retData;
    }
    const onFinalAudit = async (params:IExamine) => {
        // let { id, stocktakingCode } = detailEditForm as {id:string,stocktakingCode:string }
        // let { retData } = await stockCheckService.finalAudit({ id, stocktakingCode });
        let { retData } = await stockCheckService.finalAudit(params);
        return retData;
    }
    return {
        addModalVisible,
        detailAddForm,
        detailAddList,
        detaiAddDataRowKeys,
        detaiAddDataRow,
        detailLookForm,
        detailLookList,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        addDesc,
        editDesc,
        lookDesc,
        setAddModalVisible,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRowKeys,
        setDetaiAddDataRow,
        setDetailLookForm,
        setDetailLookList,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        setAddDesc,
        setLookDesc,
        setEditDesc,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        transformsToRoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        resetWorkloadData,
        workloadData,
        setProfitAndLoss,
        modelScreenMethod,
        onExport,
        resetAddCatch,
        resetEditCatch,
        onComplete,
        onExamine,
        onFinalAudit
    }
})